export default {
    'add-new-team': 'Add new team',
    'edit-team': 'Edit team'
}